/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum Wealthlane_AwardService_EsppAwards_Constants_EsppPurchaseStatus {
    '_0' = 0,
    '_1' = 1,
}
